var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPptSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.34167 4C4.34167 1.79086 6.13254 0 8.34167 0H24.3417L36.3417 12V36C36.3417 38.2091 34.5508 40 32.3417 40H8.34167C6.13254 40 4.34167 38.2091 4.34167 36V4Z",
    fill: "#E62E05"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M24.3417 0L36.3417 12H28.3417C26.1325 12 24.3417 10.2091 24.3417 8V0Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7919 25.6587H15.2572C16.5184 25.6587 17.3929 26.5156 17.3929 27.7812C17.3929 29.0469 16.4921 29.9038 15.2089 29.9038H13.9257V32H12.7919V25.6587ZM13.9257 26.5859V28.9897H14.954C15.767 28.9897 16.2416 28.5503 16.2416 27.7812C16.2416 27.021 15.7714 26.5859 14.9584 26.5859H13.9257ZM18.2235 25.6587H20.6888C21.9501 25.6587 22.8246 26.5156 22.8246 27.7812C22.8246 29.0469 21.9237 29.9038 20.6405 29.9038H19.3573V32H18.2235V25.6587ZM19.3573 26.5859V28.9897H20.3856C21.1986 28.9897 21.6732 28.5503 21.6732 27.7812C21.6732 27.021 21.203 26.5859 20.39 26.5859H19.3573ZM26.3358 32H25.2064V26.6167H23.308V25.6587H28.2299V26.6167H26.3358V32Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPptSvg);
export default __webpack_public_path__ + "static/media/pptSvg.2f6b8cb2e227a963410014b02230a473.svg";
export { ForwardRef as ReactComponent };